// extracted by mini-css-extract-plugin
export default {"sectionWrapper":"WalletInfo_sectionWrapper__i654w","section":"WalletInfo_section__l4dLw","sectionMiddleValue":"WalletInfo_sectionMiddleValue__ep7zm"};